/**
 * GraphQL queries and mutations for Emergency Coordinator
 */

import { gql } from '@apollo/client';

/**
 * Query: Get current participant count for emergency
 */
export const GET_EMERGENCY_PARTICIPANT_COUNT = gql`
  query GetEmergencyParticipantCount($emergencyId: ID!) {
    emergencyParticipantCount(emergencyId: $emergencyId)
  }
`;

/**
 * Query: Get recommended retry count based on participant scale
 */
export const GET_RECOMMENDED_RETRY_COUNT = gql`
  query GetRecommendedRetryCount($emergencyId: ID!) {
    recommendedRetryCount(emergencyId: $emergencyId)
  }
`;

/**
 * Mutation: Register participant in emergency
 */
export const REGISTER_EMERGENCY_PARTICIPANT = gql`
  mutation RegisterEmergencyParticipant($emergencyId: ID!, $userId: ID!) {
    registerEmergencyParticipant(emergencyId: $emergencyId, userId: $userId)
  }
`;

/**
 * Mutation: Unregister participant from emergency
 */
export const UNREGISTER_EMERGENCY_PARTICIPANT = gql`
  mutation UnregisterEmergencyParticipant($emergencyId: ID!, $userId: ID!) {
    unregisterEmergencyParticipant(emergencyId: $emergencyId, userId: $userId)
  }
`;

